import { Container, Row, Col } from "react-bootstrap";
import { OrgIdContext, ClientTypes, CustomerRelations } from "../../../store/orgId_context";
import classes from "./CustomerRelationsComponent.module.scss"
import Relation from "./Relation";
import { useContext } from "react";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleIcon from '@mui/icons-material/People';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import { DDD, E2Data} from "../../../lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data_EU_AOrg = new E2Data("EU_AOrg");
const ddd = new DDD(apiRequestAddress);

const CustomerRelationsComponent = () =>{
    const { isIntegrator, ISVCustomer, clientType, customerRelation, setCustomerRelationHandler, aboutOrgId } = useContext(OrgIdContext);
    
    const onActvateClick = (relation) => {
        setCustomerRelationHandler(relation);
        e2Data_EU_AOrg.filter = `Id="${aboutOrgId}"`;
        e2Data_EU_AOrg.values = {CustomerRelation : relation}
        e2Data_EU_AOrg.Modify();
        ddd.InvalidateSessionExtensions();
    }
    return(
        <>
        <Container>
            <Row style={{textAlign:"left"}}>
                <h2 style={{textAlign:"center"}}>For your customers</h2>
                <p style={{textAlign:"left"}}>Here you can select what relationship your customers have with and you. The relationships are dependent on
                two things:</p>
                <ul>
                    <li><h5>Bussiness relationship</h5></li>
                    Here you decide how you wish your bussiness relationship to flow with regards to our company and your customers. And potentially between
                    your customers and our services/support.
                    <li><h5>Operative control relationship</h5></li>
                    Here you decide what do you wish your customers to have control over. Will you setup all the necessary information needed for your customers
                    to be able to use our services, or will the customers do it themselves?
                </ul>
            </Row>
            <Row>
                <Col className = "col-12 col-md-12 col-lg-12 col-xl-6 h-100">
                <Row className="">
                    <Col className = "col-12 col-md-6">
                        <Relation relationTitle={"None"} 
                        icon={<DoNotDisturbIcon/>} 
                        relation={CustomerRelations.None} 
                        active={customerRelation === CustomerRelations.None ?  "true" : "false"} 
                        onActivateClick={onActvateClick}>
                        
                            <h4>No relations</h4>
                            <p>Our customers will do all the necessary functionality in our solution. 
                                They won't have any interactive account in your service. 
                                They will probably even not be aware about your service.</p>
                        </Relation>
                    </Col>
                    <Col className = "col-12 col-md-6">
                        <Relation 
                        relationTitle={"Customer administration"} 
                        icon={<PeopleAltIcon/>} 
                        relation={CustomerRelations.AdminByCustomer}
                        active={customerRelation === CustomerRelations.AdminByCustomer ?  "true" : "false"} 
                        onActivateClick={onActvateClick}>
                            <p>We'll set up an interactive account for your service, allowing the customer's admin to manage and control the invoice flow.
                                 The support for e-invoicing and fiscalization features to end-users will be provided by our company. Only, we will have
                                  the business relations with your service.</p>
                        </Relation>
                    </Col>
                </Row>
                </Col>
                <Col className = "col-12 col-md-12 col-lg-12 col-xl-6 h-100">
                <Row>
                <Col className = "col-12 col-md-6">
                    <Relation 
                    relationTitle={"Customer administration, DDD support"} 
                    icon={<PeopleIcon/>} 
                    relation={CustomerRelations.SupportByDDD}
                    active={customerRelation === CustomerRelations.SupportByDDD ?  "true" : "false"}  
                    onActivateClick={onActvateClick}>
                    We'll set up an interactive account for your service, allowing the customer's admin to manage and control the invoice flow.
                    Our customers will receive full support from your service and will be in direct business relations with your service.
                    </Relation>
                </Col>
                <Col className = "col-12 col-md-6">
                    <Relation relationTitle={"Full"} 
                    icon={<JoinFullIcon/>} 
                    relation={CustomerRelations.EIOL}
                    active={customerRelation === CustomerRelations.EIOL ?  "true" : "false"}  
                    onActivateClick={onActvateClick}>
                    We will send the invoice data to the service's API. All other actions about e-invoices or fiscalized invoices our customers
                     will make in the interactive end users' module inside your service. They will choose the needed business package and will 
                     directly pay for it to you.
                    </Relation>
                </Col>
                </Row>
                </Col>
            </Row>
        </Container>
        </>
    )
}

export default CustomerRelationsComponent;